<template>
  <div id="portalConfirmModal">
    <div class="modal-card" style="width:900px;">
      <header class="modal-card-head">
        <p class="modal-card-title" style="color: whitesmoke;">ポータル公開設定情報</p>
      </header>
      <section class="modal-card-body">
        <div class="condition-area">
          <table>
            <tr>
              <th>
                情報ポータル公開範囲
              </th>
              <td>
                <b-checkbox class="columnCheckBox" disabled v-model="portalSettingInfo.isEnabledNotice">お知らせ</b-checkbox>
                <b-checkbox class="columnCheckBox" disabled v-model="portalSettingInfo.isEnabledGuidance">ご案内</b-checkbox>
                <b-checkbox class="columnCheckBox" disabled v-model="portalSettingInfo.isEnabledEvent">学会・イベント情報</b-checkbox>
                <b-checkbox class="columnCheckBox" disabled v-model="portalSettingInfo.isEnabledNews">ニュース</b-checkbox>
                <b-checkbox class="columnCheckBox" disabled v-model="portalSettingInfo.isEnabledProduct">製品情報</b-checkbox>
              </td>
            </tr>
            <tr>
              <th style="width: 220px">定期メール送信設定</th>
              <td>
                <b-checkbox class="columnCheckBox" disabled v-model="portalSettingInfo.isEnabledMail">定期メールを送信する</b-checkbox>
              </td>
            </tr>
          </table>
        </div>
      </section>
      <footer class="modal-card-foot" style="display: flex; justify-content: center;">
        <b-button class="withButton" @click="$parent.close()">閉じる</b-button>
      </footer>
    </div>
  </div>
</template>
<script>
export default {
  name: "PortalConfirmModal",
  props: {
    portalSettingInfo:{type: Object, default: () => ({}) },
  },
  data() {
    return {};
  },
};
</script>


// WEBPACK FOOTER //
// src/components/mock/philips/common/PortalConfirmModal.vue